import LottoOdd from '@core/models/lotto/LottoOdd';
import LottoStatistics from '@core/models/lotto/LottoStatistics';
import IEvent from '@src/core/models/base/IEvent';
import Rule from '../shared/betSlip/Rule';
import DateUtils from '@utils/date/DateUtils';

export default class LottoEvent implements IEvent {
    // event id
    id: number;
    // lotto game id, game has multiple events. Example: game Grecia Keno has events every 5 mins
    lottoId: number;
    code: number;
    fullName: string;
    name: string;
    date: Date;
    // date when last bet should be accepted for this event
    endBet?: Date;
    // example lotto 7/39 has numbersDrawn: 7 and totalNumbers: 39
    numbersDrawn: number;
    totalNumbers: number;
    odds: LottoOdd[];
    rules: Rule[];

    results?: string[];

    stats?: { statistics: LottoStatistics };
}

export function isAvailableForBetting(date: Date, endBet?: Date | null) {
    const now = new Date();

    if (endBet) {
        return DateUtils.isBefore(now, endBet);
    }

    return DateUtils.isBefore(now, date);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/lotto/LottoEvent.ts